<template>
  <div class="page-my">
    <div class="my-content">
      <div class="my-body">
        <div class="flex flex-cross-center flex-main-justify benefits-box">
          <div class="flex-1">
            <div class="profit-box flex flex-main-justify">
              <div>
                <!-- 投资回报 -->
                <span v-if="profitMode == '1'">{{ $t("m.recovered") }}：</span>
                <!-- 预期收入 -->
                <span v-else>{{ $t("m.gained") }}：</span>
                <span class="gained">{{ handlePowerDataShow(gained) }}</span>
              </div>
              <div class="flex flex-cross-center">
                <span v-if="profitMode == '1'"
                  >{{ $t("m.totalInvestment") }}：</span
                >
                <span v-else>{{ $t("m.tenYearsExpectGained") }}：</span>
                <span class="gained">{{
                  handlePowerDataShow(expectGain)
                }}</span>
                <i
                  class="el-icon-edit edit-icon"
                  @click="showEditExpectedReturnModel"
                ></i>
                <div class="pr" v-show="false">
                  <i
                    class="el-icon-s-tools cp"
                    @click.stop="changeSelectBoxShow"
                  ></i>
                  <div class="select-box" v-show="selectBoxShow">
                    <el-radio
                      v-model="profitMode"
                      label="1"
                      @input="getIncome"
                      >{{ $t("m.returnOfInvestment") }}</el-radio
                    >
                    <el-radio
                      v-model="profitMode"
                      label="2"
                      @input="getIncome"
                      >{{ $t("m.expectGained") }}</el-radio
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="progress-box pr">
              <div
                class="progress-investment progress-one"
                :style="{
                  width: investmentPercent + '%',
                  'z-index': investmentPercentLevel
                }"
              ></div>
              <div
                class="progress-benefit progress-one"
                :style="{
                  width: gainPercent + '%',
                  'z-index': benefitPercentLevel
                }"
              >
                <span class="percent" :class="{ lt10: gainPercent < 8 }"
                  >{{ gainPercent }}%</span
                >
              </div>
              <div class="progress-total progress-one">
                <!-- <span class="param-name">{{ $t("m.urealisedBenefits") }}</span> -->
              </div>
            </div>
            <div class="flex">
              <div class="investment-legend">
                <span class="icon gained-icon"></span>
                <span class="param-name">{{ $t("m.gained") }}</span>
              </div>
              <div class="investment-legend">
                <span class="icon unrealized-icon"></span>
                <span class="param-name">{{ $t("m.unrealisedBenefits") }}</span>
              </div>
            </div>
          </div>
          <div class="flex capacity-box">
            <div class="capacity-one import-capacity">
              <p class="param-name">{{ $t("m.importCapacity") }}:</p>
              <p class="param-value">{{ handleDataShow(importCapacity) }}kW</p>
            </div>
            <div class="capacity-one export-capacity">
              <p class="param-name">{{ $t("m.exportCapacity") }}:</p>
              <p class="param-value">{{ handleDataShow(exportCapacity) }}kW</p>
            </div>
          </div>
        </div>
        <div class="cycle-select">
          <div class="flex flex-main-justify flex-cross-center">
            <el-radio-group
              v-model="selectedCycle"
              fill="#0093FF"
              @input="selectCycle"
              :border="false"
            >
              <el-radio-button :label="1">{{
                $t("m.lastMonth")
              }}</el-radio-button>
              <el-radio-button :label="3">{{
                $t("m.lastThreeMonths")
              }}</el-radio-button>
              <el-radio-button :label="6">{{
                $t("m.lastSixMonths")
              }}</el-radio-button>
              <el-radio-button :label="12">{{
                $t("m.thisYear")
              }}</el-radio-button>
            </el-radio-group>

            <el-date-picker
              v-model="selectedTime"
              type="monthrange"
              @change="handleMonthSelect"
              :picker-options="pickerOptions"
              start-placeholder="Start time"
              end-placeholder="End time"
            >
            </el-date-picker>
          </div>
          <div
            class="flex flex-main-justify flex-cross-center revenues-content"
          >
            <div class="revenues-chart-box pr">
              <div class="revenues-chart" ref="revenues-chart"></div>
              <div class="tip tac">
                {{ $t("m.totalBenefits") }}： {{ handleTotalBenefitsText() }}
              </div>
            </div>
            <div class="revenues-list flex flex-main-justify flex-cross-center">
              <div
                v-if="selectedAssetObj.bindingBillTypeCodeList.includes('30')"
                class="info-one-box"
                @mouseenter="changeTipModalShow('chargingRevenues', true)"
                @mouseleave="changeTipModalShow('chargingRevenues', false)"
              >
                <div
                  class="tip charging-revenues tac"
                  v-show="tipShowObj['chargingRevenues']"
                >
                  <p class="title">{{ $t("m.chargingRevenues") }}：</p>
                  <p class="description">
                    {{ $t("m.chargingRevenuesDescription") }}
                  </p>
                </div>
                <div class="company-logo-box">
                  <img
                    class="company-logo"
                    :src="renenuesData.chargerRevenuesUrl"
                    alt=""
                  />
                </div>
                <img
                  src="../assets/img/revenues-Charging.png"
                  alt=""
                  class="bg-img"
                />
                <div
                  class="content charging-revenues flex flex-dir-top flex-main-center"
                >
                  <p>
                    {{ $t("m.chargingRevenues") + " (" + getMoneyUnit() + ")" }}
                  </p>
                  <p>
                    {{ handleDataShow(renenuesData.chargerRevenues) }}
                  </p>
                </div>
              </div>
              <div
                v-if="selectedAssetObj.bindingBillTypeCodeList.includes('50')"
                class="info-one-box"
                @mouseenter="changeTipModalShow('estimatedSavings', true)"
                @mouseleave="changeTipModalShow('estimatedSavings', false)"
              >
                <div
                  class="tip charging-revenues tac"
                  v-show="tipShowObj['estimatedSavings']"
                >
                  <p class="title">{{ $t("m.estimatedSavings") }}：</p>
                  <p class="description">
                    {{ $t("m.estimatedSavingsDescription") }}
                  </p>
                </div>
                <div class="company-logo-box">
                  <img
                    class="company-logo v2power"
                    :src="renenuesData.estimatedSavingsUrl"
                    alt=""
                  />
                </div>
                <img
                  src="../assets/img/revenues-Savings.png"
                  class="bg-img"
                  alt=""
                />
                <div
                  class="content estimated-savings flex flex-dir-top flex-main-center"
                >
                  <p>
                    {{ $t("m.estimatedSavings") + " (" + getMoneyUnit() + ")" }}
                  </p>
                  <p>
                    {{ handleDataShow(renenuesData.estimatedSavings) }}
                  </p>
                </div>
              </div>
              <div class="info-one-box" v-if="selectedAssetObj.bindingBillTypeCodeList.includes('10')">
                <div class="company-logo-box">
                  <img
                    class="company-logo"
                    :src="renenuesData.importBillUrl"
                    alt=""
                  />
                </div>
                <img
                  src="../assets/img/revenues-Import.png"
                  class="bg-img"
                  alt=""
                />
                <div
                  class="content import-cost flex flex-dir-top flex-main-center"
                >
                  <p>
                    {{ $t("m.importCost") + " (" + getMoneyUnit() + ")" }}
                  </p>
                  <p>
                    {{ handleDataShow(renenuesData.importBill) }}
                  </p>
                </div>
              </div>
              <div
                v-if="selectedAssetObj.bindingBillTypeCodeList.includes('20')"
                class="info-one-box"
                @mouseenter="changeTipModalShow('exportRevenues', true)"
                @mouseleave="changeTipModalShow('exportRevenues', false)"
              >
                <div
                  class="tip export-revenues tac"
                  v-show="tipShowObj['exportRevenues']"
                >
                  <p class="title">{{ $t("m.exportRevenues") }}：</p>
                  <p class="description">
                    {{ $t("m.exportRevenuesDescription") }}
                  </p>
                </div>
                <div class="company-logo-box">
                  <img
                    class="company-logo fs"
                    :src="renenuesData.benefitExportUrl"
                    alt=""
                  />
                </div>
                <img
                  src="../assets/img/revenues-Export.png"
                  class="bg-img"
                  alt=""
                />
                <div
                  class="content export-revenues flex flex-dir-top flex-main-center"
                >
                  <p>
                    {{ $t("m.exportRevenues") + " (" + getMoneyUnit() + ")" }}
                  </p>
                  <p>
                    {{ handleDataShow(renenuesData.benefitExport) }}
                  </p>
                </div>
              </div>
              <div class="info-one-box" v-if="selectedAssetObj.bindingBillTypeCodeList.includes('40')">
                <div class="company-logo-box">
                  <img
                    class="company-logo"
                    :src="renenuesData.ancillaryServiceUrl"
                    alt=""
                  />
                </div>
                <img
                  src="../assets/img/revenues-Import.png"
                  class="bg-img"
                  alt=""
                />
                <div
                  class="content ancillary-service flex flex-dir-top flex-main-center"
                >
                  <p>
                    {{ $t("m.ancillaryServiceRevenues") + " (" + getMoneyUnit() + ")" }}
                  </p>
                  <p>
                    {{ handleDataShow(renenuesData.ancillaryService) }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="table-box">
          <p class="title">{{ $t("m.statements") }}({{ getMoneyUnit() }})</p>
          <el-table
            :data="statementList"
            style="width: 100%"
            :height="tableHeight"
            v-if="tableHeight"
            :empty-text="' '"
          >
            <el-table-column prop="billMonth" label="Month"> </el-table-column>
            <el-table-column :label="$t('m.totalBenefits')">
              <template slot-scope="scope">{{
                handleDataShow(scope.row.totalBenefits)
              }}</template>
            </el-table-column>
            <el-table-column :label="$t('m.chargingRevenues')" v-if="this.selectedAssetObj.bindingBillTypeCodeList.includes('30')">
              <template slot-scope="scope">{{
                handleDataShow(scope.row.chargingRevenues)
              }}</template>
            </el-table-column>
            <el-table-column :label="$t('m.exportRevenues')" v-if="this.selectedAssetObj.bindingBillTypeCodeList.includes('20')">
              <template slot-scope="scope">{{
                handleDataShow(scope.row.exportRevenues)
              }}</template>
            </el-table-column>
            <el-table-column :label="$t('m.estimatedSavings')" v-if="this.selectedAssetObj.bindingBillTypeCodeList.includes('50')">
              <template slot-scope="scope">{{
                handleDataShow(scope.row.estimatedSavings)
              }}</template>
            </el-table-column>
            <el-table-column :label="$t('m.ancillaryService')" v-if="this.selectedAssetObj.bindingBillTypeCodeList.includes('40')">
              <template slot-scope="scope">{{
                handleDataShow(scope.row.ancillaryService)
              }}</template>
            </el-table-column>
            <el-table-column :label="$t('m.importCost')" v-if="this.selectedAssetObj.bindingBillTypeCodeList.includes('10')">
              <template slot-scope="scope">{{
                handleDataShow(scope.row.importCost)
              }}</template>
            </el-table-column>
            <el-table-column :label="$t('m.statement')">
              <template slot-scope="scope">
                <el-tooltip
                  class="item"
                  popper-class="download-type-select"
                  effect="light"
                  placement="top"
                  v-if="scope.row.downloadList.length"
                >
                  <div slot="content">
                    <p
                      v-for="item in scope.row.downloadList"
                      :key="item.monthBillId"
                      @click="downloadFile(item, scope.row.billMonth)"
                    >
                      {{ item.billName }}
                    </p>
                  </div>
                  <i class="el-icon-download"></i>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <div class="modal" v-show="editExpectedReturnModalShow">
      <div class="modal-body tvac">
        <div class="modal-header">
          {{ $t("m.edit") + " " + $t("m.tenYearsExpectGained") }}
        </div>
        <el-input v-model="editExpectedReturnValue"></el-input>
        <div class="operate-box">
          <el-button @click="hideEditExpectedReturnModel">{{
            $t("m.cancelBtn")
          }}</el-button>
          <el-button type="primary" @click="updateLifeTimeExpectedReturn">{{
            $t("m.submit")
          }}</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      statementList: [],
      tipShowObj: {
        chargingRevenues: false,
        estimatedSavings: false,
        exportRevenues: false
      },
      importCapacity: 0,
      exportCapacity: 0,
      chartRevenues: null,
      renenuesData: {
        estimatedSavings: 0,
        totalBenefits: 0,
        chargerRevenues: 0,
        benefitExport: 0,
        importBill: 0,
        list: []
      },
      editExpectedReturnModalShow: false,
      editExpectedReturnValue: 0,
      investmentPercent: 0,
      benefitPercent: 0,
      investmentPercentLevel: 2,
      benefitPercentLevel: 3,
      investment: 0,
      tableData: [],
      accountData: {},
      accountMonthChart: null,
      accountMonthOption: {},
      chartsData: {
        monthlySavings: {
          total: "14316.79",
          electricityFees: "10000.79",
          powerGenerationIncome: "4316"
        }
      },
      selectBoxShow: false,
      profitMode: "2",
      assetSearchValue: "",
      siteList: [],
      selectedSite: "",
      replaceFields: {
        children: "assetsList",
        title: "name",
        key: "id"
      },
      axisLableColor: "rgba(207, 212, 221, 0.8)",
      expandRowKeys: [],
      // 获取row的key值
      getRowKeys(row) {
        return row.id;
      },
      accountMonthModalShow: false,
      uploadModalShow: false,
      countryList: [],
      selectedCountry: "",
      assetList: [],
      contractList: [],
      selectedContractObj: {},
      checkList: [],
      selectedMonth: "2022-01",
      selectedAsset: "",
      selectedFile: "",
      monthCharts: null,
      dayCharts: null,
      option: {},
      series: [],
      paramViewType: "40",
      selectedDataDay: "2022-03-17",
      accountDayModalShow: false,
      socketToken: "",
      thingsBoardId: "",
      realSOCList: [],
      selectedCycle: "1",
      selectedTime: "",
      accountMode: "year",
      cycleIncomeTitle: {
        month: {
          saving: "monthlySaving",
          electricitySaving: "monthlyElectricitySaving",
          powerGenerationIncome: "monthlyPowerGenerationIncome"
        },
        year: {
          saving: "annualSaving",
          electricitySaving: "annualElectricitySaving",
          powerGenerationIncome: "annualPowerGenerationIncome"
        },
        fromInstall: {
          saving: "totalSaving",
          electricitySaving: "totalElectricitySaving",
          powerGenerationIncome: "totalPowerGenerationIncome"
        }
      },
      gained: "",
      expectGain: "",
      gainPercent: 0,
      unitObj: {
        zh: {},
        en: {}
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        }
      },
      chartResizeTimer: null,
      tableHeight: 0
    };
  },
  props: ["selectedAssetObj", "selectedSiteInfo"],
  watch: {
    selectedSiteInfo() {
      this.getIncome();
      this.getAccount();
      this.getStatementList();
    }
  },
  created() {
    this.getIncome();
    this.getAccount();
    this.getStatementList();
    // 收益单位设置
    this.unitObj.zh[
      this.selectedAssetObj.countryName
    ] = this.selectedAssetObj.countryUnit;
    this.unitObj.en[
      this.selectedAssetObj.countryName
    ] = this.selectedAssetObj.countryCurrency;
  },
  mounted() {
    document.body.addEventListener("click", this.hideSelectBoxShow);
    window.addEventListener("resize", this.chartResize);
    this.tableHeight = 0;
    this.tableHeight =
      document.querySelector(".my-body").offsetHeight -
      document.querySelector(".benefits-box").offsetHeight -
      document.querySelector(".cycle-select").offsetHeight -
      90;
    console.log(this.tableHeight, "table height");
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.chartResize);
  },
  methods: {
    handleTotalBenefitsText() {
      let str = "";
      if (this.selectedAssetObj.bindingBillTypeCodeList.includes('30')) {
        str = str + this.$t("m.chargingRevenues");
      }
      if (this.selectedAssetObj.bindingBillTypeCodeList.includes('50')) {
        str = str + '+' + this.$t("m.estimatedSavings");
      }
      if (this.selectedAssetObj.bindingBillTypeCodeList.includes('20')) {
        str = str + '+' + this.$t("m.exportRevenues");
      }
      if (this.selectedAssetObj.bindingBillTypeCodeList.includes('40')) {
        str = str + '+' + this.$t("m.ancillaryService");
      }
      return str;
    },
    chartResize() {
      this.chartResizeTimer && clearTimeout(this.chartResizeTimer);
      this.chartResizeTimer = setTimeout(() => {
        this.chartRevenues && this.chartRevenues.resize();
      }, 600);
    },
    // 货币的单位
    getMoneyUnit() {
      return this.selectedSiteInfo.siteUnit || "";
    },
    changeTipModalShow(mode, val) {
      this.tipShowObj[mode] = val;
    },
    handleDataAndUnit(data, cityName) {
      if (this.$i18n.locale == "en") {
        return this.unitObj.en[cityName] + data;
      } else {
        return data + this.unitObj.ch[cityName];
      }
    },
    renderRevenuesChart() {
      this.chartRevenues = this.$echarts.init(this.$refs["revenues-chart"]);
      let option = {
        // tooltip: {
        //   trigger: "item"
        // },
        title: {
          zlevel: 0,
          text: this.handleDataShow(this.renenuesData.totalBenefits),
          subtext: "Total benefits",
          top: "55%",
          left: "50%",
          textAlign: "center",
          textStyle: {
            color: "#00A5DF",
            fontSize: 26
          },
          subtextStyle: {
            fontSize: 20,
            color: "#333"
          }
        },
        tooltip: {
          trigger: "item"
        },
        series: {
          name: "",
          type: "pie",
          radius: ["70%", "100%"],
          center: ["50%", "70%"],
          startAngle: 180,
          endAngle: 360,
          label: {
            // position: "inside",
            // color: "#fff",
            fontSize: 14
          },
          data: []
        }
      };
      if (this.selectedAssetObj.bindingBillTypeCodeList.includes('30')) {
        option.series.data.push({
          value: this.renenuesData.chargerRevenues,
          name: "Charging revenues",
          itemStyle: {
            color: "#00B2A9"
          }
        });
      }
      if (this.selectedAssetObj.bindingBillTypeCodeList.includes('50')) {
        option.series.data.push({
          value: this.renenuesData.estimatedSavings,
          name: "Estimated Savings",
          itemStyle: {
            color: "#00A5DF"
          }
        });
      }
      if (this.selectedAssetObj.bindingBillTypeCodeList.includes('20')) {
        option.series.data.push({
          value: this.renenuesData.benefitExport,
          name: "Export revenues",
          itemStyle: {
            color: "#FFB200"
          }
        });
      }
      if (this.selectedAssetObj.bindingBillTypeCodeList.includes('40')) {
        option.series.data.push({
          value: this.renenuesData.ancillaryService,
          name: "Ansillary Service",
          itemStyle: {
            color: "#FF9E1B"
          }
        });
      }
      this.chartRevenues.setOption(option, true);
    },
    hideEditExpectedReturnModel() {
      this.editExpectedReturnModalShow = false;
    },
    showEditExpectedReturnModel() {
      this.editExpectedReturnModalShow = true;
      this.editExpectedReturnValue = this.expectGain;
    },
    updateLifeTimeExpectedReturn() {
      this.$http
        .post("/statement/manage/editLifeTimeExpectedReturn", {
          spSiteId: this.selectedAssetObj.spSiteId,
          lifeTimeExpectedReturn: this.editExpectedReturnValue || 100
        })
        .then(res => {
          console.log(res, "updateLifeTimeExpectedReturn");
          this.$message.success(this.$t("m.savedTip"));
          this.getIncome();
          this.hideEditExpectedReturnModel();
        });
    },
    isCurrentMonth(month) {
      return (
        this.$dayjs(month).format("YYYY-MM") ==
        this.$dayjs(Date.now()).format("YYYY-MM")
      );
    },
    downloadFile(item, month) {
      if (item.billType == 50) {
        this.downloadExcel(month, item.billName);
      } else {
        this.downloadPdf(item.monthBillId, item.billName);
      }
    },
    downloadExcel(month, fileName) {
      this.$http
        .post(
          "/statement/manage/downloadExcel",
          {
            billMonth: month,
            spSiteId: this.selectedAssetObj.spSiteId
          },
          {},
          {
            responseType: "arraybuffer"
          }
        )
        .then(res => {
          console.log(res, "res excel");
          const _res = res;
          let blob = new Blob([_res], {
            type:
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          });
          let downloadElement = document.createElement("a");
          let href = window.URL.createObjectURL(blob); // 创建下载的链接
          downloadElement.href = href;
          downloadElement.download = fileName;
          document.body.appendChild(downloadElement);
          downloadElement.click(); // 点击下载
          document.body.removeChild(downloadElement); // 下载完成移除元素
          window.URL.revokeObjectURL(href); // 释放掉blob对象
        });
    },
    downloadPdf(id, name) {
      this.$http
        .get(
          "/statement/manage/downloadBill/" + id,
          {},
          {},
          {
            responseType: "arraybuffer"
          }
        )
        .then(res => {
          console.log(res, "res");
          const _res = res;
          let blob = new Blob([_res], { type: "application/octet-stream" });
          let downloadElement = document.createElement("a");
          let href = window.URL.createObjectURL(blob); // 创建下载的链接
          downloadElement.href = href;
          downloadElement.download = name;
          document.body.appendChild(downloadElement);
          downloadElement.click(); // 点击下载
          document.body.removeChild(downloadElement); // 下载完成移除元素
          window.URL.revokeObjectURL(href); // 释放掉blob对象
        });
    },
    getIncome() {
      this.$http
        .get("/statement/manage/topInfo/" + this.selectedAssetObj.spSiteId)
        .then(res => {
          console.log(res, "income");
          const data = res.data;
          this.gained = data.achievedBenefits;
          this.expectGain = data.lifeTimeExpectedReturn;
          this.importCapacity = data.maxImportCapacity;
          this.exportCapacity = data.maxExportCapacity;
          if (this.gained && this.expectGain) {
            this.gainPercent = Number(
              ((this.gained / this.expectGain) * 100).toFixed(2)
            );
          } else {
            this.gainPercent = 100;
          }
        });
    },
    selectCycle(val) {
      this.selectedTime = "";
      this.getAccount();
    },
    handlePowerDataShow(data) {
      return data ? this.getMoneyUnit() + " " + this.handleDataShow(data) : 0;
    },
    // 数据保留两位小数，使用三位分节法
    handleDataShow(data) {
      return data ? Number(Number(data).toFixed(2)).toLocaleString() : 0;
    },
    changeSelectBoxShow() {
      this.selectBoxShow = !this.selectBoxShow;
    },
    hideSelectBoxShow() {
      this.selectBoxShow = false;
    },
    handleMonthSelect() {
      this.selectedCycle = "";
      this.getAccount();
    },
    getMonthBeforeFormatted(monthsBefore) {
      const now = new Date();
      const currentYear = now.getFullYear();
      const currentMonth = now.getMonth(); // 注意：getMonth() 返回的月份是从 0 开始的
      // 计算目标月份的年份和月份
      let targetMonth = currentMonth - monthsBefore;
      let targetYear = currentYear;
      // 处理月份小于 0 的情况，需要借位到前一年
      if (targetMonth < 0) {
        targetMonth += 12;
        targetYear -= 1;
      }
      // 格式化月份为两位数
      const monthFormatted = (targetMonth + 1).toString().padStart(2, "0");
      // 返回 YYYY-MM 格式的字符串
      return `${targetYear}-${monthFormatted}`;
    },
    getAccount() {
      let param = {
        spSiteId: this.selectedAssetObj.spSiteId
      };
      if (this.selectedCycle) {
        // 快捷选择最近几个月
        param.startMonth = this.getMonthBeforeFormatted(this.selectedCycle);
        param.endMonth = this.getMonthBeforeFormatted(1);
      } else {
        // 自定义选择某个月份
        param.startMonth = this.$dayjs(this.selectedTime[0]).format("YYYY-MM");
        param.endMonth = this.$dayjs(this.selectedTime[1]).format("YYYY-MM");
      }
      this.$http.post("/statement/manage/timeSlot", param).then(res => {
        console.log(res, "account");
        const data = res.data;
        if (data) {
          this.renenuesData = {
            estimatedSavings: data.estimatedSavings,
            estimatedSavingsUrl: data.energySavingIconUrl,
            totalBenefits: data.totalBenefits,
            chargerRevenues: data.chargingRevenues,
            chargerRevenuesUrl: data.chargerIconUrl,
            benefitExport: data.exportRevenues,
            benefitExportUrl: data.exportIconUrl,
            importBill: data.importCost,
            importBillUrl: data.importIconUrl,
            ancillaryService: data.ancillaryService,
            ancillaryServiceUrl: data.ancillaryServiceIconUrl
          };
        } else {
          this.renenuesData = {
            estimatedSavings: 0,
            totalBenefits: 0,
            chargerRevenues: 0,
            benefitExport: 0,
            importBill: 0
          };
        }
        this.$nextTick(() => {
          this.renderRevenuesChart();
        });
        setTimeout(() => {
          this.renderRevenuesChart();
        }, 5000);
      });
    },
    handleMonthShow(val) {
      return this.$dayjs(
        this.$dayjs(this.selectedTime).format("YYYY") + "-" + val
      ).format("MMM-YYYY");
    },
    getStatementList() {
      this.$http
        .get("/statement/manage/list/" + this.selectedAssetObj.spSiteId)
        .then(res => {
          console.log(res, "list");
          res.data.sort((a, b) => {
            return new Date(b.billMonth) - new Date(a.billMonth);
          })
          this.statementList = res.data;
        });
    }
  }
};
</script>

<style lang="scss">
@import "../assets/scss/variables.scss";

.download-type-select {
  box-shadow: $boxShadow;
  border: none !important;
  z-index: 99 !important;

  p {
    cursor: pointer;
    line-height: 0.34rem;
  }
}

.el-date-picker__header {
  border-bottom: 0 !important;
}

.el-picker-panel {
  background: #fff !important;
}

.el-month-table {
  td.today .cell,
  td .cell:hover {
    color: $activeBgColor !important;
  }

  td.current:not(.disabled) .cell {
    background-color: $activeBgColor !important;
    color: #fff !important;
  }
}

.poper-down {
  .down {
    color: #0093ff;
    cursor: pointer;
    line-height: 0.3rem;
  }
}

.page-my {
  .country-asset-list {
    width: 260px;
    height: 100%;
    border-right: 1px solid #e5e9ec;
    flex-grow: 0;
    flex-shrink: 0;
    background-color: #f3f5f9;

    .asset-search-box {
      padding: 0.2rem 0.4rem;

      .asset-search-input {
        box-sizing: border-box;
      }
    }

    .title-box {
      .title-text {
        font-weight: 600;
        color: $normalColor;
        font-size: 0.18rem;
        height: 0.54rem;
        line-height: 0.64rem;
        padding-left: 0.3rem;
        margin-bottom: 0;
      }
    }

    .site-one {
      color: $normalColor;
      padding: 0 0.4rem;
      height: 0.68rem;
      line-height: 0.68rem;
      border-bottom: 1px solid rgba(51, 51, 51, 0.1);

      &.selected {
        background: $activeBgColor;
        color: #fff;
        border-color: $activeBgColor;
      }
    }
  }

  .my-content {
    flex: 1;
    height: 100%;

    .my-body {
      padding: 0 0.04rem;
      height: calc(100vh - 0.92rem);
      overflow-y: auto;

      .el-date-editor {
        height: 0.4rem;

        input {
          border-radius: 0.08rem 0.08rem 0 0;
        }
      }
    }

    .capacity-box {
      .capacity-one {
        min-width: 1.5rem;
        height: 1rem;
        background: #fff;
        box-shadow: $boxShadow;
        border-radius: 4px;
        padding: 0.2rem;

        .param-name {
          color: $normalColor;
          font-size: 0.2rem;
        }

        .param-value {
          font-size: 0.24rem;
        }

        &.import-capacity {
          margin: 0 0.2rem;

          .param-value {
            color: #00a5df;
          }
        }

        &.export-capacity {
          .param-value {
            color: #ffb200;
          }
        }
      }
    }

    .progress-box {
      height: 0.24rem;
      margin-bottom: 0.2rem;

      .progress-one {
        position: absolute;
        left: 0;
        height: 100%;
        max-width: 100%;

        span {
          color: $normalColor;
          font-size: 0.12rem;
        }

        &.progress-total {
          width: 100%;
          background-color: #d7edf9;
          border-radius: 0.06rem;
          z-index: 1;

          .param-name {
            position: absolute;
            right: 0.2rem;
            bottom: -0.04rem;
            transform: translateY(100%);
          }
        }

        &.progress-benefit {
          background-color: #00a5df;
          border-radius: 0.06rem 0 0 0.06rem;

          .percent {
            position: absolute;
            height: 0.24%;
            line-height: 0.24rem;
            color: #fff;
            right: 0.1rem;
            font-weight: bold;

            &.lt10 {
              left: 0.1rem;
              right: auto;
            }
          }

          .param-name {
            width: 100%;
            text-align: center;
            position: absolute;
            bottom: -0.04rem;
            transform: translateY(100%);
            min-width: 1rem;
          }
        }
      }
    }

    .investment-legend {
      margin-right: 0.1rem;

      .icon {
        display: inline-block;
        width: 0.1rem;
        height: 0.1rem;
        background-color: #d7edf9;
        margin-right: 0.06rem;

        &.gained-icon {
          background-color: #00a5df;
        }
      }

      .param-name {
        color: $normalColor;
        font-size: 0.12rem;
      }
    }

    .el-progress-bar__outer {
      background-color: #013366;
    }

    .profit-box {
      margin-top: 0.2rem;
      margin-bottom: 0.1rem;

      .edit-icon {
        margin-left: 0.1rem;
        color: $activeBgColor;
        font-weight: bold;
        cursor: pointer;
        font-size: 0.16rem;
      }

      span {
        color: $normalColor;
        font-weight: bold;
      }

      .el-icon-s-tools {
        margin-left: 0.1rem;
      }

      .select-box {
        position: absolute;
        bottom: -10px;
        transform: translateY(100%);
        z-index: 99;
        background: #1f1f1f;
        padding: 0.1rem 0.2rem;
        box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.2),
          0px 6px 16px 0px rgba(0, 0, 0, 0.32),
          0px 3px 6px -4px rgba(0, 0, 0, 0.48);
      }
    }

    .cycle-select {
      margin-top: 20px;

      input {
        color: $normalColor;
      }

      .download-btn {
        border-color: $borderColor;
        margin-left: 0.1rem;
      }

      .el-range-input {
        background: none;
      }
    }

    .el-radio-button {
      &:last-child {
        .el-radio-button__inner::after {
          display: none;
        }
      }
    }

    .el-radio-group {
      .el-radio-button__orig-radio:checked + .el-radio-button__inner {
        background-color: $activeBgColor !important;
        border-color: $activeBgColor !important;
        color: #fff;
      }
    }

    label {
      height: 100%;
    }

    .el-radio-button__inner {
      width: 1.4rem;
      border: 1px solid rgba(51, 51, 51, 0.1);
      position: relative;
      color: $activeBgColor;
      height: 100%;
      border-radius: 0.08rem 0.08rem 0 0;
    }

    .revenues-content {
      width: 100%;
      box-shadow: $boxShadow;
      .revenues-list {
        margin-right: 0.4rem;
        padding: 0.2rem 0;
        width: 6.4rem;
        height: 4.6rem;
        flex-wrap: wrap;
        .info-one-box {
          height: 1.2rem;
        }
      }
    }

    .revenues-chart-box {
      padding-bottom: 0.2rem;
      .tip {
        bottom: 0;
        width: 6rem;
      }
    }

    .revenues-chart {
      width: 8rem;
      height: 3rem;
    }

    .saving-box {
      margin-bottom: 0.2rem;
    }

    .info-one-box {
      width: 3rem;
      box-shadow: 0px 0px 4px 0px rgba(51, 51, 51, 0.1);
      border-radius: 5px;
      // box-shadow: 0 0 5px #111;
      box-shadow: $boxShadow;
      position: relative;
      cursor: pointer;
      margin-bottom: 0.2rem;
      &:nth-child(2n+1) {
        margin-right: 0.4rem;
      }
      &.w-100 {
        width: 100%;
        margin-top: 0.2rem;
      }
      .tip {
        box-shadow: $boxShadow;
        width: 120%;
        z-index: 9;
        background-color: #fff;
        padding: 0.1rem 0.2rem;

        &.charging-revenues {
          top: -0.2rem;
          transform: translate(-50%, -100%);

          .title {
            color: #41bc40;
            font-weight: bold;
          }
        }

        &.export-revenues {
          bottom: -0.2rem;
          transform: translate(-50%, 100%);

          .title {
            color: #41bc40;
            font-weight: bold;
          }
        }
      }

      &:last-child {
        margin-right: 0;
      }
      .company-logo-box {
        height: 0.4rem;
      }
      .company-logo {
        height: 0.4rem;

        // &.v2power {
        //   height: 0.3rem;
        //   margin: 0.05rem;
        // }

        // &.fs {
        //   height: 0.3rem;
        //   margin: 0.05rem;
        // }
      }

      p {
        margin-bottom: 0;
      }

      .bg-img {
        position: absolute;
        right: 0;
        bottom: 0;
        color: rgba(42, 49, 51, 0.8);
        font-size: 0.8rem;
        transform: translate(30%, 40%);
        z-index: 10;
        width: 0.6rem;
      }

      .content {
        overflow: hidden;
        position: relative;
        padding: 0.1rem;
        width: 100%;
        height: 0.8rem;
        border-radius: 4px;

        &.charging-revenues {
          background-color: #00b2a9;
        }

        &.estimated-savings {
          background-color: #00a5df;
        }

        &.export-revenues {
          background-color: #ffb200;
        }

        &.ancillary-service {
          background-color: #ff9e1b;
        }
        &.import-cost {
          background-color: #999999;
        }

        .param-name {
          margin-right: 0.1rem;
          margin-bottom: 0.12rem;
        }

        & > p {
          position: relative;
          z-index: 2;
          color: #fff;

          &:last-child {
            font-size: 0.3rem;
          }
        }

        &:last-child {
          margin-right: 0;
        }

        & > img {
          position: absolute;
          right: 0;
          bottom: 0;
          color: rgba(42, 49, 51, 0.8);
          font-size: 0.8rem;
          transform: translate(30%, 30%);
          z-index: 10;

          &.el-icon-sort {
            transform: translate(20%, 20%) rotate(90deg);
          }
        }
      }
    }

    .table-box {
      box-shadow: $boxShadow;
      margin-top: 20px;

      .title {
        font-weight: 600;
        color: $normalColor;
        font-size: 0.18rem;
        padding: 0 10px;
        height: 40px;
        line-height: 40px;
      }

      .el-icon-download {
        margin-left: 0.3rem;
        cursor: pointer;
        color: $activeBgColor;
        font-size: 0.24rem;
      }
    }
  }

  .header {
    height: 0.38rem;
    line-height: 0.38rem;
    padding-left: 0.2rem;
    border-bottom: 1px solid #393c47;
    width: 100%;

    span {
      margin-right: 0.2rem;
      padding: 0.04rem 0.1rem;
      height: auto;
      font-size: 0.12rem;
      border-radius: 0.02rem;
      color: #788e9f;

      &.active {
        color: #0093ff;
        background-color: rgb(35, 36, 44);
      }
    }
  }

  .el-table {
    background: none;
    box-sizing: border-box;

    &.asset-list {
      padding-top: 0.2rem;

      tr {
        th:first-child,
        td:first-child {
          padding-left: 0.6rem;
        }
      }
    }

    &::before {
      height: 0;
    }

    tr {
      &:hover {
        td {
          background: none;
        }
      }
    }

    th,
    tr,
    td {
      background: none;
      border-color: #393c47;
    }

    .can-click {
      color: #0099ff;
      cursor: pointer;
    }
  }

  .modal {
    .modal-body {
      width: 4rem !important;
      height: 2.6rem !important;
      background-color: #fff;
      box-shadow: rgba(51, 51, 51, 0.1);
      border-radius: 4px;

      .el-button {
        margin-left: 0.2rem;

        &.el-button--default {
          border-color: $borderColor;
        }
      }

      .modal-header {
        padding: 0.2rem;
        position: relative;
        color: $normalColor;

        .title {
          font-size: 0.32rem;
          color: #fff;
          margin-right: 0.4rem;
        }

        input {
          background: none;
        }

        .total {
          font-size: 0.22rem;
          color: #fff;
        }

        .el-icon-error {
          color: $normalColor;
          font-size: 0.28rem;
          cursor: pointer;
          position: absolute;
          right: 0.4rem;
          top: 0.4rem;
        }
      }

      .el-input {
        padding: 0 0.2rem;

        input {
          color: $normalColor;
        }
      }

      .operate-box {
        margin: 0.2rem;
        float: right;
      }

      .time-list {
        tr,
        td,
        th {
          border: none;
        }
      }
    }

    &.account-day-modal {
      .el-icon-error {
        position: absolute;
        top: 0.1rem;
        right: 0.1rem;
      }

      .modal-body {
        width: 12rem;
      }

      .modal-content {
        height: 6rem;
        overflow-y: auto;
        padding: 0 0.4rem 0.4rem 0.4rem;
      }

      .account-day-charts {
        width: 100%;
        height: 3rem;
        margin: 0 auto;
      }

      .soc-line-charts {
        width: 100%;
        height: 2.3rem;
        margin: 0 auto;
      }
    }

    &.account-month-modal {
      .el-icon-error {
        position: absolute;
        top: 0.1rem;
        right: 0.1rem;
      }

      .modal-body {
        width: 12rem;
      }

      .modal-content {
        padding: 0.4rem;

        .el-table {
          border: 0;

          &::before,
          &::after {
            width: 0;
            height: 0;
          }
        }

        .infos-box {
          margin: 0.1rem 0.2rem;
          width: 100%;

          .info-one-box {
            width: 30%;
            margin-right: 4%;
            background-color: rgb(32, 32, 38);
            border-radius: 5px;
            box-shadow: 0 0 5px #111;
            position: relative;
            &.w-100 {
              width: 100%;
            }
            .content {
              overflow: hidden;
              position: relative;
              padding: 0.2rem;
              width: 100%;
              height: 100%;

              & > p {
                position: relative;
                z-index: 2;

                &:last-child {
                  margin-top: 0.12rem;
                  font-size: 0.16rem;
                  color: #fff;
                }
              }

              &:last-child {
                margin-right: 0;
              }

              & > i {
                position: absolute;
                right: 0;
                bottom: 0;
                color: rgba(42, 49, 51, 0.8);
                font-size: 0.8rem;
                transform: translate(30%, 30%);
                z-index: 1;

                &.el-icon-sort {
                  transform: translate(20%, 20%) rotate(90deg);
                }
              }
            }
          }

          .total-text {
            margin-top: 0.2rem;
          }
        }
      }

      .data-title {
        margin-bottom: 0.1rem;

        span {
          display: inline-block;
          width: 1rem;
        }
      }

      .data-value {
        span {
          display: inline-block;
          width: 1rem;
        }
      }

      .charts {
        width: 4rem;
        height: 400px;
        margin-right: 0.4rem;
      }
    }
  }
}
</style>
